
















import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  name: "OptionItem",
  setup() {
    const isOpen = ref(false);

    const onToggle = () => {
      isOpen.value = !isOpen.value;
    };

    return {
      isOpen,
      onToggle,
    };
  },
});
